import React from 'react';
import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../../../mobx/bridge';
import styles from './TransferLocationsList.module.css';
import TransferLocationsListItem from '../TransferLocationsListItem/TransferLocationsListItem';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const TransferLocationsList = observer(function TransferLocationsList() {
  const { commonStore } = useRootStore();
  const { t } = useTranslation();

  const closeTransferList = () => {
    commonStore.setTransferLocationListOpen(false);
  };

  return (
    <Grid component="div" container>
      <Grid
        component="div"
        container
        item
        xs={12}
        justify="center"
        alignItems="center"
        className={styles.topBar}
      >
        <Grid component="div" item xs={11} align="left">
          <span className={styles.topBarHeader}>
            {t('TransferLocationsList.TransferConversationTitle')}
          </span>
        </Grid>

        <Grid
          component="div"
          container
          item
          xs={1}
          align="center"
          className={styles.closeBtnContainer}
        >
          <button
            type="button"
            className={styles.closeBtn}
            onClick={closeTransferList}
            data-testid="closeBtn"
          />
        </Grid>
      </Grid>

      <Grid component="div" item xs={12} className={styles.container}>
        {commonStore.getTransferLocationsList.map((location) => (
          <Grid component="div" item xs={12} key={location.CPLocationID}>
            <TransferLocationsListItem location={location} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
});
TransferLocationsList.whyDidYouRender = true;
TransferLocationsList.displayName = 'TransferLocationsList';

export default TransferLocationsList;
